import script from "./PackageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageForm.vue?vue&type=script&setup=true&lang=ts"

import "./PackageForm.vue?vue&type=style&index=0&id=087edafc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087edafc"]])

export default __exports__